import { IResidentContact } from 'Modules/Communication/Contacts/shared/models/Contacts'
import { getActiveClientId } from 'shared/store/clients/selectors'
import { RootState, emptySplitApi } from 'shared/store/store'
import { axiosErrorMessageHelper } from 'shared/utils/axiosErrorMessageHelper'
import { isUndefined } from 'shared/utils/isUndefined'
import {
  getMessagesContactsFilters,
  getMessagesUnitsFilters,
} from './selectors'
import { ICommonListModel } from 'shared/models/Common'
import { IUnitResponseModel } from 'Modules/HousingAssociation/OurCompany/shared/models/Unit'

const errors = {
  resident: 'Noe gikk galt under uthenting av kontakter',
  units: 'Noe gikk galt under uthenting av enheter',
}
const BASE_URL_CLIENTS = 'client/clients/'
const BASE_URL_UNITS = 'hu/client/'

const messagesFiltersService = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getMessagingResidentContacts: build.query<
      ICommonListModel<IResidentContact>,
      void
    >({
      async queryFn(_, { getState }, _extraOptions, query) {
        const state = getState() as RootState
        // @ts-expect-error todo
        const filters = getMessagesContactsFilters(state)
        const clientId = getActiveClientId(state)

        if (isUndefined(clientId))
          return { error: 'Klientid mangler i kall for å hente kontakter' }

        const res = await query({
          url: `${BASE_URL_CLIENTS}${clientId}/contacts/query`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: { ...filters },
        })
        if (res.error) {
          return {
            error: axiosErrorMessageHelper(res.error, {
              fallbackError: errors.resident,
              withMessagePrefix: true,
            }),
          }
        }

        return { data: res.data as ICommonListModel<IResidentContact> }
      },
    }),

    getMessagingUnits: build.query<IUnitResponseModel, void>({
      async queryFn(_, { getState }, _extraOptions, query) {
        const state = getState() as RootState
        // @ts-expect-error todo
        const filters = getMessagesUnitsFilters(state)
        const clientId = getActiveClientId(state)

        const res = await query({
          url: `${BASE_URL_UNITS}${clientId}/units`,
          method: 'POST',
          headers: {
            'x-api-version': '2.0',
          },
          data: { ...filters },
        })
        if (res.error) {
          return {
            error: axiosErrorMessageHelper(res.error, {
              fallbackError: errors.units,
              withMessagePrefix: true,
            }),
          }
        }
        return { data: res.data as IUnitResponseModel }
      },
    }),
  }),
})

export default messagesFiltersService
